import {modifyHexColorAlpha} from '@/utils';

import {getBrandableFieldsFromOverlayOptions} from '@/mixins/overlayOptions';

export function redirectToCreateBrandingPage(vm, redirectFeedbackType = null) {
  function redirect() {
    vm.$store.commit('SET_CONTENTCREATOR_DRAWER_ITEMS_EXPANDED', true);
    vm.$router.push({name: 'branding', query: {create: true}});
  }

  if (redirectFeedbackType === 'alert') {
    vm.$bus.$emit('alert-info', {
      message: 'tvtemplatesPleaseCreateBrandingTitle',
      translate: true,
      timeout: 6000,
    });
    redirect();
    return;
  }

  // No feedback desired.
  redirect();
}

export function chooseDefaultBrandingFromBrandings(brandings) {
  // Workaround for #2045: If there is no default Branding, assume
  //  the first Branding as default even if not marked as such. This
  //  is to avoid running into situations where we do have
  //  Brandings, but none is applied, breaking all previews.
  let branding = brandings.filter((branding) => branding.is_default)[0];
  if (!branding && brandings.length > 0) {
    branding = brandings[0];
  }
  return branding;
}

/**
 * Return cached Branding from TVSpot produced from TVTemplate.
 *
 * This can be used as a fallback for brandable editable HTML-Spots that
 * are activated by Users that have no Content-Creator/Branding of their
 * own, see https://github.com/myshopradio/cms/issues/2151.
 */
export function getFallbackBrandingFromTVSpotTemplateData(tvspot) {
  if (tvspot && tvspot.template_data && tvspot.template_data.branding) {
    return tvspot.template_data.branding;
  }
  return null;
}

/**
 * Functionality used to list and apply Brandings on TVTemplates.
 *
 * Parent must handle the actual update themselves, these methods only
 * compute and return the necessary changeset (which fields get which
 * new values).
 *
 * Depends on:
 *   - this.$store.state.common.brandings
 */
export default {
  computed: {
    brandings() {
      return this.$store.state.common.brandings;
    },
    hasBrandings() {
      return this.brandings.length > 0;
    },
    defaultBranding() {
      return chooseDefaultBrandingFromBrandings(this.brandings);
    },
  },
  methods: {
    getChangesetToApplyBranding(branding, overlayOptions, debug = false) {
      const brandableFields =
        getBrandableFieldsFromOverlayOptions(overlayOptions);
      if (!brandableFields) {
        return;
      }

      const changeset = {};
      for (let fieldName of Object.keys(brandableFields)) {
        const fieldData = brandableFields[fieldName];
        if (!branding.hasOwnProperty(fieldData.from_branding)) {
          continue;
        }

        let newValue = branding[fieldData.from_branding];

        // COLOR fields do support modifying transparency on top.
        if (
          fieldData.kind === 'COLOR' &&
          fieldData.from_branding_with_alpha !== undefined
        ) {
          const alpha = fieldData.from_branding_with_alpha;
          newValue = modifyHexColorAlpha(newValue, alpha);
        }

        if (debug) {
          console.log(
            '[DEBUG] Apply branding: "' +
              branding.name +
              '".' +
              fieldData.from_branding,
            '-> overlay_data.' + fieldName,
            '=',
            newValue
          );
        }

        if (fieldData.value === newValue) {
          continue;
        }

        changeset[fieldName] = newValue;
      }
      return changeset;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/tvtemplateBrandings.js